export default "__VITE_ASSET__DAPP9ubG__"